import React, { useEffect, useRef } from 'react'

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'

const StepBar: React.FunctionComponent = () => {
  const { state, getters, actions } = useSubBuilder()
  const stepList = getters.getCurrentStepList()
  const bar = useRef(null)
  const currentBar: HTMLUListElement = bar.current
  
  const handleScroll = () => {
    
    const header: HTMLHeadingElement = document.querySelector('[data-section-id="header"]')
    const uspBanner: HTMLDivElement = document.querySelector('[data-usp-banner]')
    const { height }: { height: number } = header.getBoundingClientRect()
    //Usp banner might be hidden
    const usp = uspBanner ? uspBanner.getBoundingClientRect().height : 0
    const total = height + usp
    currentBar.style.cssText = `position: sticky; top: ${total}px; z-index: 10`
  }

  useEffect(() => {
    if (currentBar) {
      window.addEventListener('scroll', handleScroll)
    }
    return () => window.removeEventListener('scroll', handleScroll);
  }, [state])

  return <>
    <ul className="step-bar flex" ref={bar}>
      <li className={`${state.step === null ? 'is-active ' : ''}is-completed step-bar-item`}>
        <button onClick={() => actions.setStep(null)}><span className="step-bar-number">1.</span><span className="step-bar-label">Who</span></button></li>
      {stepList.map((item, i) => {
        return (
          <li key={item} className={`${item === state.step ? 'is-active ' : ''}${i < stepList.indexOf(state.step) ? ' is-completed ' : ''}step-bar-item`}>
            {stepList.indexOf(item) < stepList.indexOf(state.step) && (<button onClick={() => actions.setStep(item)}> <span className="step-bar-number">{i + 2}</span>. <span className="step-bar-label">{item}</span></button>)}
            {stepList.indexOf(item) === stepList.indexOf(state.step) && (<span> <span className="step-bar-number">{i + 2 }</span>. <span className="step-bar-label">{item}</span></span>) }
            {stepList.indexOf(item) > stepList.indexOf(state.step) && (<span> <span className="step-bar-number">{i + 2 }</span>. <span className="step-bar-label">{item}</span></span>) }
          </li>)
      })}
    </ul>
  </>
}

export default StepBar